import ApiService from "@/core/services/api.service";

const actions = {
  /**
   *
   * @param context
   * @param payload
   * @returns {*}
   */
  updateSchoolLeaveDetails(context, payload) {
    ApiService.setHeader();
    return ApiService.post("school/leave/management/update", payload).then(
      (res) => {
        return res;
      }
    );
  },
};

export default {
  actions,
};
